import Faqs from "components/components/Iris/LandingPageInfo/Faqs/Faqs";
import GetStartedSection from "components/components/Iris/LandingPageInfo/GetStartedSection/GetStartedSection";
import IrisHeader from "components/components/Iris/LandingPageInfo/IrisHeader/IrisHeader";
import UsefulLinks from "components/components/Iris/UsefulLinks/UsefulLinks";
import PageMeta from "components/components/Meta/PageMeta";
import React from "react";

import { IrisBlueDivider, IrisPageFrame } from "./style";

export type ButtonProps = {
  buttonText: string;
  onClick: () => void;
};

type Props = {
  buttonProps: ButtonProps;
};

const LandingPageInfo: React.FC<Props> = ({ buttonProps }) => (
  <IrisPageFrame>
    <PageMeta title="IRIS" />
    <IrisHeader buttonProps={buttonProps} />
    <div className="container px-5">
      <IrisBlueDivider />
    </div>
    <GetStartedSection />
    <br />
    <div className="container px-5">
      <UsefulLinks />
    </div>
    <Faqs />
  </IrisPageFrame>
);

export default LandingPageInfo;
